import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import AuthService from "./AuthService";
import axiosInstance from "./axiosInstance";


const studentMenuSections = [
  {
    title: "Student Home",
    items: [
      { label: "My Dashboard", icon: "bi-speedometer2", path: "/dashboard" },
      { label: "My Profile", icon: "bi-person-circle", path: "/student/profile" },
      { label: "School Communications", icon: "bi-megaphone", path: "/student/communications" },
      { label: "Class Notices", icon: "bi-pin-angle", path: "/student/class-notices" },
      { label: "AI Study Assistant", icon: "bi-stars", path: "/student/ai-assistant" },
    ],
  },
  {
    title: "My Academics",
    items: [
      { label: "My Timetable", icon: "bi-calendar2-week", path: "/student/timetable" },
      { label: "My Learning", icon: "bi-play-circle", path: "/student/learning" },
      { label: "My Results & Reports", icon: "bi-journal-check", path: "/student/results" },
      { label: "ICT & Robotics", icon: "bi-cpu", path: "/student/ict-robotics" },
    ],
  },
  {
    title: "My Services",
    items: [
      { label: "My Fees", icon: "bi-cash-stack", path: "/student/finance" },
      { label: "My Library", icon: "bi-book", path: "/student/library" },
    ],
  },
  {
    title: "School Life",
    items: [
      { label: "Events & Sports", icon: "bi-calendar-event", path: "/student/events-sports" },
      { label: "My Conduct", icon: "bi-shield-check", path: "/student/conduct" },
    ],
  },
];


const teacherMenuSections = [
  {
    title: "Teacher Home",
    items: [
      { label: "My Dashboard", icon: "bi-speedometer2", path: "/dashboard" },
      { label: "My Profile", icon: "bi-person-circle", path: "/teacher/profile" },
      { label: "School Communications", icon: "bi-megaphone", path: "/teacher/communications" },
      { label: "Class Notices", icon: "bi-pin-angle", path: "/teacher/class-notices" },
      { label: "Parent Reports", icon: "bi-chat-left-dots", path: "/teacher/parent-reports" },
      { label: "AI Teaching Assistant", icon: "bi-stars", path: "/teacher/ai-assistant" },
    ],
  },
  {
    title: "Teaching",
    items: [
      { label: "My Timetable", icon: "bi-calendar2-week", path: "/teacher/timetable" },
      { label: "My Classes", icon: "bi-people", path: "/teacher/classes" },
      { label: "My Subjects", icon: "bi-journal-bookmark", path: "/teacher/subjects" },
      { label: "Marks Entry", icon: "bi-pencil-square", path: "/teacher/marks" },
      { label: "Learning Resources", icon: "bi-play-circle", path: "/teacher/learning" },
      { label: "Live Classes", icon: "bi-camera-video", path: "/teacher/live-classes" },
    ],
  },
  {
    title: "Class Management",
    items: [
      { label: "Students", path: "/teacher/students", icon: "bi-people", capability: "is_class_teacher" },
      { label: "Conduct Records", icon: "bi-shield-check", path: "/teacher/conduct" },
      { label: "ICT & Robotics", icon: "bi-cpu", path: "/teacher/ict-robotics", capability: "has_ict_robotics" },
    ],
  },
  {
    title: "School Services",
    items: [
      { label: "Library History", icon: "bi-book", path: "/teacher/library" },
      { label: "Events & Sports", icon: "bi-calendar-event", path: "/teacher/events-sports" },
    ],
  },

];


const parentMenuSections = [
  {
    title: "Parent Home",
    items: [
      { label: "My Dashboard", icon: "bi-speedometer2", path: "/dashboard" },
      { label: "My Profile", icon: "bi-person-circle", path: "/parent/profile" },
      { label: "Parent AI Assistant", icon: "bi-stars", path: "/parent/ai-assistant" },
      { label: "School Communications", icon: "bi-megaphone", path: "/parent/announcements" },
      { label: "Class Notices", icon: "bi-pin-angle", path: "/parent/class-notices" },
      { label: "Report to Class Teacher", icon: "bi-chat-left-text", path: "/parent/reports" },
    ],
  },
  {
    title: "My Children",
    items: [
      { label: "Children Overview", icon: "bi-people", path: "/parent/children" },
      { label: "Learning, Results & Child Services", icon: "bi-journal-richtext", path: "/parent/children" },
      { label: "ICT & Robotics", icon: "bi-cpu", path: "/parent/children" },
    ],
  },
  {
    title: "School Life",
    items: [
      { label: "Events & Sports", icon: "bi-calendar-event", path: "/parent/children" },
    ],
  },
];

const deputyHeadMenuSections = [
  {
    title: "Deputy Head's Office",
    items: [
      { label: "Executive Dashboard", icon: "bi-speedometer2", path: "/dashboard", permission: "dashboard.view" },
      { label: "Enrolment Overview", icon: "bi-person-plus", path: "/students", permission: "students.view" },
      { label: "Assessments, Exams & Results", icon: "bi-journal-check", path: "/results", permission: "results.view" },
      { label: "CALA / Projects", icon: "bi-kanban", path: "/elearning", permission: "elearning.view" },
      { label: "Child Safety & Discipline", icon: "bi-shield-check", path: "/discipline", permission: "discipline.view" },
      { label: "Communications & Leadership", icon: "bi-megaphone", path: "/deputy-head/communications", permission: "headmaster.view" },
      { label: "Events & Sports", icon: "bi-calendar-event", path: "/events", permission: "events.view" },
      { label: "AI Assistant", icon: "bi-stars", path: "/ai-assistant", permission: "ai.view" },
    ],
  },
];

const headOfficeMenuSections = [
  {
    title: "Head's Office",
    items: [
      {
        label: "Executive Dashboard",
        icon: "bi-speedometer2",
        path: "/dashboard",
      },
      {
        label: "Communications & Leadership",
        icon: "bi-megaphone",
        path: "/headmaster",
        permission: "headmaster.view",
      },
      {
        label: "AI Assistant",
        icon: "bi-stars",
        path: "/ai-assistant",
        permission: "ai.view",
      },
    ],
  },
];

const menuSections = [
  {
    title: "Main",
    items: [
      { label: "Dashboard", icon: "bi-speedometer2", path: "/dashboard", permission: "dashboard.view" },
      { label: "The Head's Office", icon: "bi-bank", path: "/headmaster", permission: "headmaster.view" },
      { label: "Deputy Head's Office", icon: "bi-person-badge", path: "/deputy-head", permission: "headmaster.view" },
    ],
  },
  {
    title: "Academic",
    items: [
      { label: "Students", icon: "bi-mortarboard", path: "/students", permission: "students.view" },
      { label: "Teachers", icon: "bi-person-workspace", path: "/teachers", permission: "teachers.view" },
      { label: "Parents", icon: "bi-people", path: "/parents", permission: "parents.view" },
      { label: "E-learning", icon: "bi-play-circle", path: "/elearning", permission: "elearning.view" },
      { label: "ICT & Robotics", icon: "bi-cpu", path: "/ict-robotics", permission: "ict_robotics.view" },
      { label: "Exams & Results", icon: "bi-journal-check", path: "/results", permission: "results.view" },
    ],
  },
  {
    title: "Operations",
    items: [
      { label: "Library", icon: "bi-book", path: "/library", permission: "library.view" },
      { label: "Fees & Billing", icon: "bi-cash-stack", path: "/finance", permission: "finance.view" },
      { label: "Discipline", icon: "bi-shield-check", path: "/discipline", permission: "discipline.view" },
      { label: "Events & Sports", icon: "bi-calendar-event", path: "/events", permission: "events.view" },
      { label: "School Houses", icon: "bi-shield-fill", path: "/houses", permission: "events.view" },
      { label: "Reports", icon: "bi-file-earmark-bar-graph", path: "/reports", permission: "reports.view" },
    ],
  },
  {
    title: "Administration",
    items: [
      { label: "AI Assistant", icon: "bi-stars", path: "/ai-assistant", permission: "ai.view" },
      { label: "Settings", icon: "bi-gear", path: "/settings", permission: "settings.view" },
    ],
  },
];

function resolveMediaUrl(value) {
  if (!value) return "";
  if (value.startsWith("http://") || value.startsWith("https://")) return value;

  const apiBase = axiosInstance.defaults?.baseURL || "";
  const backendBase = apiBase.replace(/\/api\/?$/, "").replace(/\/$/, "");

  if (value.startsWith("/") && backendBase) return `${backendBase}${value}`;
  return value;
}

function Sidebar({ isOpen, onClose }) {
  const user = AuthService.getCurrentUser();
  const permissions = user?.permission_slugs || [];
  const isStudent = user?.user_type === "STUDENT";
  const isTeacher = user?.user_type === "TEACHER";
  const isParent = user?.user_type === "PARENT";
  const isHeadOffice =
    user?.user_type === "HEADMASTER" ||
    user?.user_type === "HEADMASTER_OFFICE";
  const isDeputyHead = user?.user_type === "DEPUTY_HEAD";
  const isSuperUser = user?.is_superuser || user?.user_type === "SUPER_ADMIN";
  const [schoolProfile, setSchoolProfile] = useState({
    name: "The Grange Christian School",
    logo: "",
  });
  const [teacherCapabilities, setTeacherCapabilities] = useState({});

  const handleMobileClose = () => {
    if (window.innerWidth <= 768 && typeof onClose === "function") {
      onClose();
    }
  };

  useEffect(() => {
    const loadSchoolProfile = async () => {
      try {
        const response = await axiosInstance.get("settings/school-profile/");
        setSchoolProfile(response.data || {});
      } catch (error) {
        setSchoolProfile({
          name: "The Grange Christian School",
          logo: "",
        });
      }
    };

    loadSchoolProfile();
  }, []);

  useEffect(() => {
    const loadTeacherCapabilities = async () => {
      if (!isTeacher) return;
      try {
        const response = await axiosInstance.get("teacher-portal/navigation/");
        setTeacherCapabilities(response.data?.capabilities || {});
      } catch (error) {
        setTeacherCapabilities({});
      }
    };

    loadTeacherCapabilities();
  }, [isTeacher]);

  const canView = (permission) => {
    if (isSuperUser) return true;
    if (!permission) return true;
    return permissions.includes(permission);
  };

  const logoUrl = resolveMediaUrl(schoolProfile.logo || schoolProfile.logo_url);
  const schoolName = schoolProfile.name || "The Grange Christian School";

  return (
    <>
      <div
        className={`grange-sidebar-backdrop ${isOpen ? "show" : ""}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />

      <aside
        className={`grange-sidebar text-white ${isOpen ? "is-open" : ""}`}
        style={{
          width: isOpen ? "270px" : "78px",
        }}
      >
      <div className="p-3 border-bottom border-light border-opacity-25 position-relative">
        <button
          type="button"
          className="grange-sidebar-close"
          onClick={onClose}
          aria-label="Close navigation menu"
          title="Close menu"
        >
          <i className="bi bi-x-lg"></i>
        </button>

        <div className="d-flex align-items-center gap-2">
          <div
            className="bg-white text-success fw-bold d-flex align-items-center justify-content-center overflow-hidden"
            style={{ width: 46, height: 46, borderRadius: 12, flexShrink: 0 }}
            title={schoolName}
          >
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={schoolName}
                style={{ width: "100%", height: "100%", objectFit: "contain", padding: 4 }}
              />
            ) : (
              <span>TG</span>
            )}
          </div>

          {isOpen && (
            <div style={{ minWidth: 0 }}>
              <div className="fw-bold text-truncate">{schoolName}</div>
              <small className="text-white-50">School Portal</small>
            </div>
          )}
        </div>
      </div>

      <nav className="grange-sidebar-nav p-2">
        {(
          isStudent
            ? studentMenuSections
            : isTeacher
            ? teacherMenuSections
            : isParent
            ? parentMenuSections
            : isHeadOffice
            ? headOfficeMenuSections
            : isDeputyHead
            ? deputyHeadMenuSections
            : menuSections
        ).map((section) => {
          const visibleItems = section.items.filter((item) => {
            if (item.capability && !teacherCapabilities[item.capability]) return false;
            return canView(item.permission);
          });

          if (visibleItems.length === 0) return null;

          return (
            <div key={section.title} className="mb-3">
              {isOpen && (
                <div
                  className="text-white-50 text-uppercase fw-bold px-3 mb-2"
                  style={{ fontSize: 11, letterSpacing: "0.06em" }}
                >
                  {section.title}
                </div>
              )}

              {visibleItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  title={!isOpen ? item.label : undefined}
                  onClick={handleMobileClose}
                  className={({ isActive }) =>
                    `d-flex align-items-center gap-3 px-3 py-2 mb-1 text-decoration-none rounded-3 ${
                      isActive ? "bg-white text-success fw-bold" : "text-white"
                    }`
                  }
                >
                  <i className={`bi ${item.icon}`} style={{ fontSize: "1.1rem" }}></i>
                  {isOpen && <span>{item.label}</span>}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>
      </aside>
    </>
  );
}

export default Sidebar;
